// src/pages/UserDashboard.jsx
import React, { useEffect, useState } from 'react';
import CertificationDisplay from '../components/CertificationDisplay';
import { getUserCertifications } from '../utils/contract'; // 👈 your helper

const UserDashboard = () => {
  const [walletAddress, setWalletAddress] = useState('');
  const [certs, setCerts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCerts = async () => {
      const stored = window.localStorage.getItem('connectedWallet');
      if (stored) {
        setWalletAddress(stored);
        const certData = await getUserCertifications(stored);
        setCerts(certData);
      }
      setLoading(false);
    };

    fetchCerts();
  }, []);

  const handleLogout = () => {
    window.localStorage.removeItem('connectedWallet');
    window.location.href = '/home';
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-card">
        <h2 className="dashboard-title">Welcome to Your Dashboard</h2>
        <p className="wallet-info">Wallet: <code>{walletAddress}</code></p>
        <button className="login-type-btn" onClick={handleLogout}>Logout</button>

        {loading ? (
          <p>Loading certifications...</p>
        ) : (
          <CertificationDisplay walletAddress={walletAddress} certs={certs} />
        )}
      </div>
    </div>
  );
};

export default UserDashboard;

